import api from './baseApi';
import { ImageFormats, SignedUrlImageType, SignedUrlResponse } from './typings/image';

export const getImageUploadS3SignedUrl = async (
    type: SignedUrlImageType,
    format: ImageFormats
): Promise<SignedUrlResponse> => {
    const response = await api.get('/Images/ImageUploadSignedUrl', {
        params: {
            type: type,
            format: format
        }
    });
    return response.data;
};

/**
 * The mask picker thumbnail is rendered by the client, the server only signs its upload. The key is
 * derived from the mask filename so the thumbnail path stays derivable from the mask path.
 */
export const getMaskThumbnailUploadS3SignedUrl = (filename: string): Promise<SignedUrlResponse> =>
    api.get('/Images/MaskThumbnail/SignedUrl', { params: { filename } }).then(({ data }) => data);

export const getProductThumbnailsS3SignedUrl = async (): Promise<SignedUrlResponse> => {
    const response = await api.get('/Images/ProductThumbnail/SignedUrl');
    return response.data;
};

export const getThumbnailS3SignedUrl = async (type?: SignedUrlImageType): Promise<SignedUrlResponse> => {
    const response = await api.get('/Images/Thumbnail/SignedUrl', { params: { type } });
    return response.data;
};
